"use client"
import { useSelector } from "react-redux";
import { usePathname } from 'next/navigation'
import { Box, Text } from "@quintoandar-tokko/jopijs";
import TokkobrokkerThumbnail from "@/public/tokko-vertical.svg";
import ImageNext from "@/components/shared/ImageNext";
import Trans from "@/components/shared/Trans";
import translations from './calendarLayout.trans.json'
import style from "./calendarLayout.module.scss"
import Skeletons from "@/components/fichaInfo/skelenton/Skeleton";
import { THEMES } from "@/store/slices/ThemeSlice";

export default function CalendarLayout({ children }) {
  const calendar = useSelector(state => state.CalendarSlice)
  // Only Tokko shows its logo; Univen has none and an unresolved theme shows no brand.
  const showLogo = useSelector(state => state.ThemeSlice.theme) === THEMES.TOKKOBROKER
  const pathname = usePathname()
  const { schedule, visit } = calendar
  const calendarPageIsReady = pathname.includes('/calendar/') && !schedule.initializing
  const visitPageIsReady =  pathname.includes('/visit/') && !visit.initializing
  const showTitle = schedule.isMounted || calendarPageIsReady || visitPageIsReady

  return (
    <Box className={style.calendarLayout}>
      <Box as="header" className={style.calendarLayoutHeader}>
        {showLogo && (
          <ImageNext
            className={style.calendarLayoutThumbnail}
            src={TokkobrokkerThumbnail}
            width="64"
            height="40"
            alt="tokkobroker"
            unoptimized
          />
        )}
        {showTitle
          ? <Text className={`${style.calendarLayoutTitle} ${showLogo ? style.besideLogo : ''}`}>
              {Trans(translations, "ReservationSystem")}
            </Text>
          : <Skeletons className={showLogo ? style.besideLogo : ''} width={180} height={30} borderRadius={8} />
        }

      </Box>
      <Box as="main" className={style.calendarLayoutMainContent}>
        {children}
      </Box>
    </Box>
  );
}
